import { forwardRef } from 'react';

import { useSearch } from './contexts/SearchContext';
import { SearchFieldOptions } from './SearchFieldOptions';
import { SearchResults } from './SearchResults';
import { cn } from '~/utils/cnTailwind';

export const SearchFlyout = forwardRef<HTMLDivElement>((_props, ref) => {
    const { flyoutOpen } = useSearch();

    return (
        <div
            data-testid="search-flyout"
            id="search-flyout"
            ref={ref}
            className={cn(
                'absolute mt-1 top-full left-0 right-0 bg-white h-auto overflow-auto opacity-0 transition-opacity duration-300 ease-in-out pointer-events-none rounded-b rounded-t-none shadow-md max-w-[1200px] w-[1200px] z-[100]',
                flyoutOpen ? 'flyout-open max-h-[500px] min-h-[205px] h-auto py-2 opacity-100 pointer-events-auto' : '',
            )}
        >
            <div id="search__flyout-content" className={cn('px-2', flyoutOpen ? 'px-2' : 'h-0')}>
                <div id="search__flyout-header" className="flex m-2 mt-0 pb-2 border-b border-b-[#eaeaea]">
                    <SearchFieldOptions />
                </div>
                <div id="search__flyout-body" className="flex flex-col w-full mt-2">
                    <SearchResults />
                </div>
            </div>
        </div>
    );
});

SearchFlyout.displayName = 'SearchFlyout';
